"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetsResponseToJSON = exports.DatasetsResponseFromJSONTyped = exports.DatasetsResponseFromJSON = exports.instanceOfDatasetsResponse = void 0;
var runtime_1 = require("../runtime");
var Dataset_1 = require("./Dataset");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the DatasetsResponse interface.
 */
function instanceOfDatasetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfDatasetsResponse = instanceOfDatasetsResponse;
function DatasetsResponseFromJSON(json) {
    return DatasetsResponseFromJSONTyped(json, false);
}
exports.DatasetsResponseFromJSON = DatasetsResponseFromJSON;
function DatasetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'datasets': !(0, runtime_1.exists)(json, 'datasets') ? undefined : (json['datasets'].map(Dataset_1.DatasetFromJSON)),
    };
}
exports.DatasetsResponseFromJSONTyped = DatasetsResponseFromJSONTyped;
function DatasetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'datasets': value.datasets === undefined ? undefined : (value.datasets.map(Dataset_1.DatasetToJSON)),
    };
}
exports.DatasetsResponseToJSON = DatasetsResponseToJSON;
